

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Column from '@/components/Column.vue'
import VueImgInputer from 'vue-img-inputer'
import TimerTip from '@/components/TimerTip.vue'
import AgreeIterms from '@/components/AgreeIterms.vue'
import Panel from '@/components/Panel.vue'
import Candidate from '@/components/Candidate'
import Login from '@/components/Login'

import AlertPlugin from 'vux/src/plugins/alert/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Cell from 'vux/src/components/cell/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import Datetime from 'vux/src/components/datetime/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ViewBox from 'vux/src/components/view-box/index.vue'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import XAddress from 'vux/src/components/x-address/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


Vue.component('Cell', Cell)
Vue.component('Confirm', Confirm)
Vue.component('Datetime', Datetime)
Vue.component('Group', Group)
Vue.component('Icon', Icon)
Vue.component('Popup', Popup)
Vue.component('PopupPicker', PopupPicker)
Vue.component('Sticky', Sticky)
Vue.component('Swiper', Swiper)
Vue.component('Tab', Tab)
Vue.component('Tabbar', Tabbar)
Vue.component('TabItem', TabItem)
Vue.component('ViewBox', ViewBox)
Vue.component('XAddress', XAddress)
Vue.component('XButton', XButton)
Vue.component('XDialog', XDialog)
Vue.component('XInput', XInput)
Vue.component('XNumber', XNumber)
Vue.component('XSwitch', XSwitch)
Vue.component('XTextarea', XTextarea)

Vue.use(AlertPlugin)
Vue.use(AjaxPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(WechatPlugin)

Vue.component(AgreeIterms.name, AgreeIterms)
Vue.component(Candidate.name, Candidate)
Vue.component(Column.name, Column)
Vue.component(Login.name, Login)
Vue.component(Panel.name, Panel)
Vue.component(TimerTip.name, TimerTip)
Vue.component('VueImgInputer', VueImgInputer)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
template: '<App/>',
components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js